export default __webpack_public_path__ + "images/ListadoAlbaranesBesafer4.0-FR.png";